$ = jQuery;
$("#loader").hide();
$("#ajax_fitler_search_results").hide();
$("#ajax_fitler_compare_results_1").hide(); 
$("#ajax_fitler_compare_results_2").hide(); 
loader_enable = false;
var mafs_search = $("#my-ajax-filter-search"); 
var mafsForm_search = mafs_search.find("form"); 
var current_tab_search; 
var page = 1;
var post_types = [];
var search_query_call = false;

jQuery('.search_my_text').on('input', function() {
  // do your stuff
  //alery('1');
  search_query_call = false;
  $("#ajax_fitler_search_results").hide();
  $("#ajax_pagination_search").hide();
});

 //Find Selected Genres
 function getSelectedPostType()
 {
     var posts_arrays = []; //Setup empty array     
     if($("#post_types").val() != null){
      post_types = $("#post_types").val()
     }else{
      post_types = ["producergallery","photos","articles","news"]; 
     }      
    var posts_array = [];
    for(var i = 0 ;  i < post_types.length ; i++) {
          if(post_types[i] == 'photos'){    
            posts_array.push('photos');
          }else if(post_types[i] == 'producergallery'){
            posts_array.push('producergallery');
          }else if(post_types[i] == 'articles'){
            posts_array.push('post');
          }else{
            posts_array.push('post');
          }  
        }      

     return posts_array; //Return all of the selected genres in an array
 }

 //Get Search Form Values
 function getSearchValue()
 {
        var searchValue = mafsForm_search.find("#search").val();
     return searchValue;
 }


mafsForm_search.submit(function(e){
    e.preventDefault(); 
    if(!loader_enable){
      $("#loader").show();
      loader_enable = true;
    }
    search_query_call = true;
    $("#nav-galleries-tab").hide();  
    $("#nav-photos-tab").hide();
    $("#nav-articles-tab").hide();
    $("#nav-news-tab").hide();    
    var photos = '';
    var galleries = '';
    var article = '';
    var news = '';
    var photos_tab = 0;
    var galleries_tab = 0;
    var article_tab = 0;
    var news_tab = 0;
// we will add codes above this line later
if(mafsForm_search.find("#search").val().length !== 0) {
  var search = mafsForm_search.find("#search").val();
}

if(mafsForm_search.find("#post_types").val() != null) {
   post_types = mafsForm_search.find("#post_types").val();
}else{
  $("#post_types").multiselect('selectAll', false);   
   post_types = ["producergallery","photos","articles","news"];
}
var open_tab;
var activated = post_types[0];
var posts_array = [];
for(var i = 0 ;  i < post_types.length ; i++) {
  if(post_types[i] == 'photos'){    
    posts_array.push('photos');
    photos_tab = 1;
  }else if(post_types[i] == 'producergallery'){
    posts_array.push('producergallery');
    galleries_tab = 1;
  }else if(post_types[i] == 'articles'){
    posts_array.push('press');
    article_tab = 1;
  }else{
    posts_array.push('post');
    news_tab =1;
  }
}

  if(current_tab_search !='' && current_tab_search != undefined  && post_types.includes(current_tab_search)){
    activated = current_tab_search;
  }
  //alert(activated)
  if(activated == 'photos'){    
    photos = 'active';
    open_tab = 'nav-photos';
  }else if(activated == 'producergallery' ){
    galleries = 'active';
    open_tab = 'nav-galleries';   
  }else if(activated == 'articles' ){
    article = 'active';
    open_tab = 'nav-articles';   
  }else{
    news = 'active';
    open_tab = 'nav-news';   
  }

var data = {
  action : "my_ajax_filter_search",
  search : search,
  post_types : posts_array,
  page: page,
  post_search : activated,
  post_types_checkbox : post_types
}


$.ajax({
  type: 'GET',
  url : ajax_url,
  data : data,
  dataType: "json",
  beforeSend: function ()
  {
    $('.ajax_fitler_search_results_posts').hide();
    $('#ajax_pagination_search').html(''); 
   // $("#loader").show();
  },
  success : function(data) {
    $("#ajax_pagination_search").show();
    if(galleries_tab){ 
        $("#nav-galleries-tab").show();
      }
      if(photos_tab){ 
        $("#nav-photos-tab").show();
      }
      if(article_tab){ 
        $("#nav-articles-tab").show();
      }
      if(news_tab){ 
        $("#nav-news-tab").show();
      }    
    
      $('.nav-tabs a').removeClass('active');
      if(data) {
        if(data.is_record){
        $("#ajax_fitler_search_results").show();
        $('#no_record_result').hide();    

        $('#ajax_fitler_search_results').html();  
        $(".gallery_count").html(data.count_of_search_result.gallery_count);
        $(".photo_count").html(data.count_of_search_result.photos_count);
        $(".article_count").html(data.count_of_search_result.articles_count);
        $(".news_count").html(data.count_of_search_result.news_count);

        $('.ajax_fitler_search_results_posts').show();  
        $('.nav-tabs a[href="#'+ open_tab +'"]').tab('show'); // show tab targeted by the selector
        $('#ajax_pagination_search').html(data.pagination);     
            
        } else{
          $("#ajax_fitler_search_results").hide();
          $("#loader").hide();
          loader_enable = false;
          $('#no_record_result').show();              
          var html ='';
          html += '<div class="col-sm-12 border border-color-dark p-3">';
          html += '<div class="col-xs-12" id="result_ajax">';         
          html += data.content;
          html += '</div></div>';

          $('#no_record_result').html(html);     
        }
      } else {
          var html  = "<div class='no-result text-danger'>No matching movies found. Try a different filter or search keyword</div>";
          $('#ajax_fitler_search_results').html(html);
      }
  },
  complete:function(data){
    // Hide image container
    //$("#loader").hide();
   },
  error: function (jqXHR, textStatus, errorThrown) {
    console.log("jqXHR: " + jqXHR);
    console.log("textStatus: " + textStatus);
    console.log("errorThrown: " + errorThrown);
}
});

});


//If pagination is clicked, load correct posts
$('.pagination_search a').live('click', function(e){
  e.preventDefault();

  var url = $(this).attr('href'); //Grab the URL destination as a string
  
  var paged = url.split('&paged='); //Split the string at the occurance of &paged=

  generate_post_result(paged[1]); //Load Posts (feed in paged value)
});

function generate_post_result(paged){
  $('.ajax_fitler_search_results_posts').hide();
  
  // alert(current_tab_search);

  var paged_value = paged;
  var data = {
    action : "my_ajax_filter_search",
    search : getSearchValue(),
    post_types : getSelectedPostType(),
    page: paged_value,
    post_search : current_tab_search
  }  
  $('#ajax_pagination_search').html();
  $.ajax({
    type: 'GET',
    url : ajax_url,
    data : data,
    dataType: "json",
    beforeSend: function ()
    {        //You could show a loader here
        $("#loader").show();
    },
    success : function(data) {
      $("#loader").hide();
      
        if(data) { 
          $('.ajax_fitler_search_results_posts').show();
           $('.ajax_fitler_search_results_posts').html(data.content); 
          $('#ajax_pagination_search').html(data.pagination); 
          
          if( current_tab_search == 'producergallery')
            galleries_js();   
            if( current_tab_search == 'photos')
            $('#custom-layout-demo').slickLightbox();
            $(window).scrollTop(200);
        } else {
            var html  = "<div class='no-result text-danger'>No matching movies found. Try a different filter or search keyword</div>";
            $('#ajax_pagination_search').html(html);
        }
    },
    complete:function(data){
      $("#loader").hide();
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log("jqXHR: " + jqXHR);
      console.log("textStatus: " + textStatus);
      console.log("errorThrown: " + errorThrown);
  }
  });
  
}

function galleries_js(){
  $('.gallery_search').on('init', function(event, slick){
    var lastindex = slick.currentSlide + 3;
    if(lastindex > slick.slideCount )
    lastindex = slick.slideCount;
    
    if(3 > slick.slideCount)
    lastindex = slick.slideCount;

     $(this).append(' <div class="slick-counter text-center">'+ parseInt(slick.currentSlide + 1, 10) +' -' + lastindex + ' of '+ slick.slideCount +'</div>');    
  });    
  $('.gallery_search').slick({
  slidesToShow: 3,
  slidesToScroll: 3, 
  infinite: true,
  //lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },    
  ]
  });
  var $el = $('.gallery_search');
  $($el).on('afterChange', function(event, slick, currentSlide, nextSlide){
    var lastindex = slick.currentSlide + 3;
    if(lastindex > slick.slideCount )
    lastindex = slick.slideCount;

    if(3 > slick.slideCount)
    lastindex = slick.slideCount;

        $(this).find('.slick-counter').html(slick.currentSlide + 1 + ' - '+ lastindex + ' of '+slick.slideCount);
 });  
    $('.gallery_search').slickLightbox({
            src: 'src',
            itemSelector: '.image img',
            caption: 'caption',
            captionPosition:'bottom',

      });
}

$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
  var target = $(e.target).attr("href") // activated tab
  e.preventDefault();
  if(search_query_call){

  var x =$(this).attr("id"); 
    if(x == 'nav-galleries-tab')
    current_tab_search = 'producergallery';
    else if(x == 'nav-photos-tab')
    current_tab_search = 'photos';
    else if(x == 'nav-articles-tab')
    current_tab_search = 'articles';
    else
    current_tab_search = 'news';

  var data = {
    action : "my_ajax_filter_search",
    search : getSearchValue(),
    post_types : getSelectedPostType(),
    page: page,
    post_search : current_tab_search
  }
  
  $("#ajax_pagination_search").hide();
  $('.ajax_fitler_search_results_posts').hide(); 
  
      $.ajax({
        type: 'GET',
        url : ajax_url,
        data : data,
        dataType: "json",
        beforeSend: function ()
        {        //You could show a loader here           
            if(!loader_enable){
              $("#loader").show();
              loader_enable = true;
            }
        },
        success : function(data) {
          $("#loader").hide();
          loader_enable = false;
          $("#ajax_fitler_search_results").show();
          $('.ajax_fitler_search_results_posts').show(); 

            if(data) {               
            $(target).html(data.content);
            if( current_tab_search == 'producergallery')
            galleries_js();   
            if( current_tab_search == 'photos')
            $('#custom-layout-demo').slickLightbox();
              // $('#ajax_fitler_search_results_posts').html(data.content); 
               $('#ajax_pagination_search').html(data.pagination); 
               $("#ajax_pagination_search").show();
            } else {
                var html  = "<div class='no-result text-danger'>No matching movies found. Try a different filter or search keyword</div>";
                $(target).html(html);
            }
        },
        complete:function(data){
          $("#loader").hide();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log("jqXHR: " + jqXHR);
          console.log("textStatus: " + textStatus);
          console.log("errorThrown: " + errorThrown);
      }
    });
  }
});


$(".year_option_select").click(function () {
  if(this.value == 'single'){
    $("#singleYear").removeAttr("disabled");
    $( ".range_year" ).addClass( "disable_option" );
  }else{
    $("#singleYear").val('');
    $("#singleYear").attr("disabled", "disabled");
    $( ".range_year" ).removeClass( "disable_option" );
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

$("input[name='onlynumbersyear']").on('input', function (e) {
  $(this).val($(this).val().replace(/[^0-9]/g, ''));
});

function galleries_compare_js1(noOfPhotos = 3){
  
  $('.gallery1').on('init', function(event, slick){
    var lastindex = slick.currentSlide + noOfPhotos;
    if(lastindex > slick.slideCount )
    lastindex = slick.slideCount;
    
    if(noOfPhotos > slick.slideCount)
    lastindex = slick.slideCount;

     $(this).append(' <div class="slick-counter1 text-center">'+ parseInt(slick.currentSlide + 1, 10) +' -' + lastindex + ' of '+ slick.slideCount +'</div>');    
  });    
  $('.gallery1').slick({
  slidesToShow: noOfPhotos,
  slidesToScroll: noOfPhotos, 
  infinite: false,
  // lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },    
  ]
  });
  var $el = $('.gallery1');
  $($el).on('afterChange', function(event, slick, currentSlide, nextSlide){
    var lastindex = slick.currentSlide + noOfPhotos;
    if(lastindex > slick.slideCount )
    lastindex = slick.slideCount;

    if(noOfPhotos > slick.slideCount)
    lastindex = slick.slideCount;

        $(this).find('.slick-counter1').html(slick.currentSlide + 1 + ' - '+ lastindex + ' of '+slick.slideCount);
 });  
    $('.gallery1').slickLightbox({
            src: 'src',
            itemSelector: '.image img',
            caption: 'caption',
            captionPosition:'bottom',

      });
}

function galleries_compare_js2(noOfPhotos = 3){
  
  $('.gallery2').on('init', function(event, slick){
    var lastindex = slick.currentSlide + noOfPhotos;
    if(lastindex > slick.slideCount )
    lastindex = slick.slideCount;
    
    if(noOfPhotos > slick.slideCount)
    lastindex = slick.slideCount;

     $(this).append(' <div class="slick-counter2 text-center">'+ parseInt(slick.currentSlide + 1, 10) +' -' + lastindex + ' of '+ slick.slideCount +'</div>');    
  });    
  $('.gallery2').slick({
  slidesToShow: noOfPhotos,
  slidesToScroll: noOfPhotos, 
  infinite: false,
  // lazyLoad: 'ondemand',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },    
  ]
  });
  var $el = $('.gallery2');
  $($el).on('afterChange', function(event, slick, currentSlide, nextSlide){
    var lastindex = slick.currentSlide + noOfPhotos;
    if(lastindex > slick.slideCount )
    lastindex = slick.slideCount;

    if(noOfPhotos > slick.slideCount)
    lastindex = slick.slideCount;

        $(this).find('.slick-counter2').html(slick.currentSlide + 1 + ' - '+ lastindex + ' of '+slick.slideCount);
 });  
    $('.gallery2').slickLightbox({
            src: 'src',
            itemSelector: '.image img',
            caption: 'caption',
            captionPosition:'bottom',

      });
}


$("#customCheck1").click(function(){
  $('input:checkbox').not(this).prop('checked', this.checked);
});



// Compare Function starts here
var mafs = $("#my-ajax-filter-compare"); 
var mafsForm = mafs.find("form");
var data = {'phototags': []}; 
var btn = '';
var template_directory_uri = '';

// Filter Data
$("#button_filter").click(function(e){
  e.preventDefault(); 
  $("#ajax_fitler_compare_results_1").hide();
  $("#ajax_fitler_compare_results_2").hide();
  $("#loader").show();
  btn = 'button_filter';
  $.fn.getData();
  $('.filter-box').toggleClass("d-none");   
});

// Counterfeit Search
$("#button1").click(function(e){
  e.preventDefault(); 
  $("#ajax_fitler_compare_results_1").hide();
  $("#loader").show();
  btn = 'button1';
  $.fn.getData();
});

// Counterfeit Search
$("#button2").click(function(e){
  e.preventDefault(); 
  $("#ajax_fitler_compare_results_2").hide();
  $("#loader").show();
  btn = 'button2';
  $.fn.getData();
});

// Common function created for ajax response
$.fn.myFunction = function(){ 
  var dataCompare = {
    action : "my_ajax_filter_compare",
    data: data
  }
  var noOfPhotos = (parseInt(data['noOfPhotos']) > 0) ? parseInt(data['noOfPhotos']) : 3;
  $.ajax({
    url : ajax_url,
    data : dataCompare,
    success : function(response) {
      template_directory_uri = response['template_directory_uri'];
      $.fn.displayFilters();
      // if(btn === 'button1' || btn === 'button_filter') {
      //   $('#ajax_fitler_compare_results_1').html();
      //   if(response && response['search1']) {
      //     var html  = "<div class='result-box border p-2' id='custom-layout-demo'>";
      //     html += "   <div class='row'>";
      //     for(var i = 0 ;  i < response['search1'].length ; i++) {
      //       html += "       <div class='col-sm-6'>";
      //       html += "           <div class='photo-wrap mt-2'>";
      //       html += "               <h5 class='mb-0'>" + response['search1'][i].title + "</h5>";
      //       html += "                   <a href='" + response['search1'][i].permalink + "' target='_blank' class='thumbnail' title='" + response['search1'][i].title + "'>";
      //       html += "                       <img src='" + response['search1'][i].poster['url']  + "' alt='' class='img-fluid'>";
      //       html += "                   </a>";
      //       html += "           </div>";
      //       html += "       </div>";
      //       $('#ajax_fitler_compare_results_1').html(html);
      //     }
      //     html += "   </div>";
      //     html += "</div>";
      //   } else {
      //       var html  = "<li class='no-result'>No matching records found. Try a different filter or search keyword</li>";
      //       $('#ajax_fitler_compare_results_1').html(html);
      //   }
      // }

      if(btn === 'button1' || btn === 'button_filter') {
        $("#loader").hide();
        $("#ajax_fitler_compare_results_1").show();
        $('#ajax_fitler_compare_results_1').html();
        if(response && response['search1']) {
          var html  = '<div class="container">';
          html += '<div class="slide"><div class="gallery-wrap mt-3"><div class="gallery1">';
          for(var i = 0 ;  i < response['search1'].length ; i++) {
            html += '<div class="image"> ';
            html += "<img data-caption='"+response['search1'][i].title+"' class='img-fluid thumbnail' src='" + response['search1'][i].poster['url']  + "'>";
            html += '<div class="text-brown text-center px-2 mt-2">'+ response['search1'][i].title + '</div>';
            html += "</div>";
          }
          html += "   </div>";
          html += "</div>";
          html += "   </div></div>";
          $('#ajax_fitler_compare_results_1').html(html);
          galleries_compare_js1(noOfPhotos);
        } else {
            var html  = "<div class='no-result text-danger'>No matching records found. Try a different filter or search keyword</div>";
            $('#ajax_fitler_compare_results_1').html(html);
        }
      }

      if(btn === 'button2' || btn === 'button_filter') {
        $("#loader").hide();
        $("#ajax_fitler_compare_results_2").show(); 
        $('#ajax_fitler_compare_results_2').html();
        if(response && response['search2']) {
          var html  = '<div class="container">';
          html += '<div class="slide"><div class="gallery-wrap mt-3"><div class="gallery2">';
          for(var i = 0 ;  i < response['search2'].length ; i++) {
            html += '<div class="image"> ';
            html += "<img data-caption='"+response['search2'][i].title+"' class='img-fluid thumbnail' src='" + response['search2'][i].poster['url']  + "'>";
            html += '<div class="text-brown text-center px-2 mt-2">'+ response['search2'][i].title + '</div>';
            html += "</div>";
          }
          html += "   </div>";
          html += "</div>";
          html += "   </div></div>";
          $('#ajax_fitler_compare_results_2').html(html);
          galleries_compare_js2(noOfPhotos);
        } else {
            var html  = "<div class='no-result text-danger'>No matching records found. Try a different filter or search keyword</div>";
            $('#ajax_fitler_compare_results_2').html(html);
        }
      }
    },
    complete:function(response){
      $("#loader").hide();

    } 
  });
}

// Reset Button
$("#reset_compare").click(function(e){
  $.fn.resetForm();
  $("#ajax_fitler_compare_results_1").hide();
  $("#ajax_fitler_compare_results_2").hide();
  $("#loader").show();
  $.fn.getData();
});
//Close popup
$("#cancel_compare").click(function(e){
  $.fn.resetForm();
  $('.filter-box').toggleClass("d-none");         
  e.preventDefault();
});
$.fn.resetForm = function(){ 
  ($("#dateRange").val(''));
  data['dateRange'] = '';
  $("input[name='tags[]']:checked").each( function () {
    $(this).attr('checked', false);
  });
  $("#customCheck1").attr('checked', false);
  $("#singleYear").val('');
  $("#dateRange").slider('refresh');
  $("#noOfPhotos").val('-1');
  $("#singleYear").removeAttr("disabled");
  $('#single_year_check').prop("checked", true);
  $( ".range_year" ).addClass( "disable_option" );
  $.fn.myFunction();
};

// Get Data
$.fn.getData = function(){ 
  data['phototags'] = [];
  data['noOfPhotos'] = ''
  data['search1'] = '';
  data['search2'] = '';
  data['yearTag'] = '';

  $("input[name='tags[]']:checked").each( function () {
    data['phototags'].push(this.value); 
  });
  if(mafsForm.find("#singleYear").val().length !== 0) {
    data['yearTag'] = mafsForm.find("#singleYear").val();
    data['dateRange'] = '';
  }
  if(mafsForm.find("#noOfPhotos").val().length !== 0) {
    data['noOfPhotos'] = mafsForm.find("#noOfPhotos").val();
  }
  if(mafsForm.find("#photoCategory1").val().length !== 0) {
    data['photoCategory1'] = mafsForm.find("#photoCategory1").val();
  }
  if(mafsForm.find("#search1").val().length !== 0) {
    data['search1'] = mafsForm.find("#search1").val();
  }
  if(mafsForm.find("#photoCategory2").val().length !== 0) {
    data['photoCategory2'] = mafsForm.find("#photoCategory2").val();
  }
  if(mafsForm.find("#search2").val().length !== 0) {
    data['search2'] = mafsForm.find("#search2").val();
  }
  $.fn.myFunction();
};

$("input[name='tags[]']").click(function(){
  var cnt = 0;
  $("input[name='tags[]']:checked").each( function () {
    cnt++;
  });
  if (cnt === 7) {
    $('#customCheck1').prop("checked", true);
  } else {
    $('#customCheck1').removeAttr("checked");
  }
});

$("#dateRange").change(function(){
  data['dateRange'] = '';
  if($("#dateRange").val().length !== 0) {
    data['dateRange'] = $("#dateRange").val();
  }
});

$.fn.displayFilters = function(){
  $('#selected_filters').html('');
  html = '';
  for(var i = 0 ;  i < data['phototags'].length ; i++) {
    html += '<span class="mr-2 mb-md-2"><img src="' + template_directory_uri + '/assets/images/svg/' + data['phototags'][i].toLowerCase() + '.svg" class="img-fluid" />' + data['phototags'][i] + '</span>';
  }
  if (data['dateRange']) {
    html += '<span class="date-tag"> <i class="fa fa-calendar mr-2" aria-hidden="true"></i>' + data['dateRange'].replace(",", " - ");+ '</span>';
  }
  if (data['yearTag']) {
    html += '<span class="date-tag"> <i class="fa fa-calendar mr-2" aria-hidden="true"></i>' + data['yearTag'] + '</span>';
  }
  $('#selected_filters').html(html);
}

$("#search1").keypress(function(e){
  if(e.which === 13) $("#button1").click();
});

$("#search2").keypress(function(e){
  if(e.which === 13) $("#button2").click();
});

$('#commpare_form').bind("keypress", function(e) {
  if (e.keyCode == 13) {               
    e.preventDefault();
    return false;
  }
});


// WEBPACK FOOTER //
// ./scripts/script.js